import type { ListOrdersParams } from '@/lib/api/services/orders.api';

export const orderKeys = {
  all: ['orders'] as const,
  lists: () => [...orderKeys.all, 'list'] as const,
  list: (params?: ListOrdersParams) => [...orderKeys.lists(), params] as const,
  detail: (id: number) => [...orderKeys.all, 'detail', id] as const,
};
